import { createI18n } from "vue-i18n";

const messages = {};

const supportedLanguages = ["en", "sr"]; //initialize with supported languages. Will be changed later

const defaultLanguage = "en";

const i18n = createI18n({
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  // Falling back to English for an untranslated key is expected, not worth a console warning
  fallbackWarn: false,
  messages,
  warnHtmlInMessage: "off",
});

export { i18n, supportedLanguages, defaultLanguage };
